exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.add-button[data-v-693f1775] {\n  padding: 0 0 2px 16px;\n}\n.info-tooltip[data-v-693f1775] {\n  position: absolute;\n  top: 44px;\n  right: -2%;\n  z-index: 49;\n}\n.timezone-tooltip[data-v-693f1775] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  font-size: 12px;\n  color: white;\n  background-color: #131c36;\n  border-radius: 3px;\n  padding: 14px;\n  margin-top: 10px;\n}\n.timezone-tooltip[data-v-693f1775]::after {\n  content: ' ';\n  position: absolute;\n  bottom: 53%;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 5px;\n  border-style: solid;\n  border-color: transparent transparent #131c36 transparent;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-693f1775","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/companies/CompaniesInfo.vue
// module id = 9qNV
// module chunks = 0